module.exports = __webpack_public_path__ + "img/5.2b0e1d5a.jpg";